/* eslint-disable  @typescript-eslint/no-explicit-any */

import { Module } from "vuex";

import cloneDeep from "lodash.clonedeep";

import * as treeComponent from "@/utils/tree";

import { SuppliersApi } from "@/api/suppliersApi";

import { SuppliersState, SuppliersSearchResult, TreeItem, TreeDictionary, FormattedTreeDictionary } from "@/types/suppliers";

import { supplierSearchParam } from "../_initialStateObjects";
import { TenderMvcSite } from "@/api/tenderMvc";

const SET_STATE = "SET_STATE";

export const suppliers: Module<SuppliersState, RootStateSupplierSearch> = {
    namespaced: true,
    state: {
        kladrList: undefined,
        loadingKladr: false,
        regionList: undefined,
        loadingRegions: false,
        okpd2List: undefined,
        loadingOkpd2: false,
        okpd2Promise: undefined,
        supplierSearchParam: cloneDeep(supplierSearchParam),
        suppliersSearchResult: {
            items: [],
            scores: [],
            totalItemsCount: 0
        },
        aiServiceOptionsResult: {
            code: "",
            name: "",
            fullName: ""
        }
    },
    actions: {
        async loadKladrLazily({ state, commit }) {
            if (state.loadingKladr) return;
            if (state.kladrList) return;
            commit(SET_STATE, { loadingKladr: true, loadingRegions: true });

            const rawData = (await SuppliersApi.getKladrList()).data;

            const lv12 = [] as Array<TreeItem>;
            const kv = {} as TreeDictionary;
            const frmData = [] as Array<TreeItem>;
            for (const a of rawData) {
                const {
                    code: key, level, name, parentCode: parent,
                } = a;

                if (key === '7700000000000' && level === 3) continue;
                else if (key === '7800000000000' && level === 3) continue;
                else if (key === '9200000000000' && level === 3) continue;

                const item: TreeItem = {
                    key: JSON.stringify({ key, level }), name, parent, level,
                };

                if (kv[key]) {
                    if (kv[key].level > item.level) {
                        kv[key] = item;
                    }
                } else {
                    kv[key] = item;
                }

                frmData.push(item);

                if (level === 1 || level === 2) {
                    lv12.push({
                        key, name, parent, level,
                    });
                }
            }

            for (const itm of frmData) {
                if (!treeComponent.hasValue(itm.parent)) continue;

                const po = kv[itm.parent || ''];
                if (!po) itm.parent = undefined;
                else itm.parent = JSON.stringify({ key: itm.parent, level: po.level });
            }

            const kladrList = treeComponent.flatDict(frmData);
            const regionList = treeComponent.flatDict(lv12);

            commit(SET_STATE, {
                kladrList, regionList, loadingKladr: false, loadingRegions: false,
            });
        },
        async loadOkpd2({ commit }) {
            const okpd2Data = (await SuppliersApi.getOkpd2List()).data;
            const okpd2List = treeComponent.flatTree(okpd2Data);
            commit(SET_STATE, { okpd2List, loadingOkpd2: false });
        },
        async loadOkpd2Lazily({ state, dispatch, commit }) {
            if (state.okpd2List) {
                return;
            }

            if (state.loadingOkpd2) {
                await state.okpd2Promise;
                return;
            }

            const okpd2Promise = dispatch("loadOkpd2");

            commit(SET_STATE, { okpd2Promise, loadingOkpd2: true });

            await okpd2Promise;
        },
        async searchSuppliers({ state, commit }) {
            const suppliersSearchResult = (await SuppliersApi.search(state.supplierSearchParam)).data;

            commit(SET_STATE, { suppliersSearchResult });
        },
        async loadAiServiceSuggestions({ commit }, aiServiceOptions) {
            const res = (await TenderMvcSite.getAiServiceSuggestions(aiServiceOptions)).data;
            const json = JSON.parse(res);
            const aiServiceOptionsResult = {
                code: json.okei_codes[0].code,
                name: json.okei_codes[0].name,
                fullName: json.okei_codes[0].full_name,
            }
            commit(SET_STATE, { aiServiceOptionsResult });
        },
        async clearSuppliers({ commit }) {
            const suppliersSearchResult = {
                items: [],
                scores: [],
                totalItemsCount: 0
            };

            commit(SET_STATE, { suppliersSearchResult });
        },
    },
    mutations: {
        [SET_STATE](state: any, payload: any) {
            for (const key in payload) {
                state[key] = payload[key];
            }
        },
        clearSearchParams(state: SuppliersState) {
            state.supplierSearchParam.filter = cloneDeep(supplierSearchParam).filter;
        },
        prefillSuppliersSearchNames(state: SuppliersState, payload: string) {
            state.supplierSearchParam.filter.name = [payload];
        },
    },
    getters: {
        okpd2Tree(state: SuppliersState): { items: FormattedTreeDictionary; rootKeys: Array<string> } | null {
            return treeComponent.formatOkpd2Tree(state.okpd2List);
        },
        kladrTree(state: SuppliersState): { items: FormattedTreeDictionary; rootKeys: Array<string> } | null {
            return treeComponent.formatTree(state.regionList);
        },
        suppliersSearchResult(state: SuppliersState): SuppliersSearchResult | undefined {
            return state.suppliersSearchResult;
        }
    },
};